import {
    Button,
    Dialog,
    Divider,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import Webcam from "react-webcam";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddIcon from "@mui/icons-material/Add";
import LocalSeeIcon from "@mui/icons-material/LocalSee";
import { useTheme } from '../../../../components/hooks/useTheme';
import useAuth from '../../../../components/hooks/useAuth';
import axios from 'axios';
import baseURL from '../../../../configs/api';
import PleaseWaitPopup from '../../../PleaseWaitPopup';
import colorConfigs from '../../../../configs/colorConfigs';
import CustomFormatDatePicker from '../../../../components/common/CustomFormatDatePicker';
import { validateMin } from '../../../../utils/validateMin';
import {
    ContentState,
    EditorState,
    convertFromHTML,
    convertToRaw,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import useConfirm from "../../../../components/hooks/useConfirm";
import useGeneral from "../../../../components/hooks/useGeneral";
import Cookies from "js-cookie";
import { handleCapture } from "../../../../utils/covertTheBase64FormatIntoImage";
import useDelete from "../../../../components/hooks/useDelete";
import { delete_fileUpload, put_fileUpload } from "../../../../services/appFileUpload";
import { CustomImagePopup } from "../../../../components/common/CustomImagePopup";
import useTenant from "../../../../components/hooks/useTenant";

type EditRepairOrderProps = {
    idNumber: any;
    openEditRepairOrder: boolean;
    setOpenEditRepairOrder: (value: boolean) => void;
    setRefreshRepairOrderList: (value: boolean) => void;
    repairOrderId: number;
}

export const EditRepairOrder = ({ idNumber, openEditRepairOrder, setOpenEditRepairOrder, setRefreshRepairOrderList, repairOrderId }: EditRepairOrderProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { themeStyles } = useTheme();
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const { dateFormat }: any = useGeneral();  
    const [odometerOut, setOdometerOut] = useState("0");
    const [odometerIn, setOdometerIn] = useState("0");
    const [total, setTotal] = useState<string>("0");
    const [showWebcam, setShowWebcam] = useState<boolean>(false);
    const [filePath, setFilePath] = useState<any[]>([]);
    const [newFilePath, setNewFilePath] = useState<string[]>([]);
    const [fileIndex, setFileIndex] = useState<number>(-1);
    const [imagePopup, setImagePopup] = useState<boolean>(false);
    const [maintenanceType, setMaintenanceType] = useState<string>("");
    const [maintenanceTypeOptions, setMaintenanceTypeOptions] = React.useState([]);
    const [totalInParts, setTotalInParts] = useState(0);
    const [totalInLabour, setTotalInLabour] = useState(0);
    const [notes, setNotes] = useState<string>("");
    const [dateOut, setDateOut] = useState<string>("");
    const [timeOut, setTimeOut] = useState<string>("T00:00:00");
    const [dateDue, setDateDue] = useState<string>("");
    const [timeDue, setTimeDue] = useState<string>("T00:00:00");
    const [mechanic, setMechanic] = useState<string>("");
    const [mechanicComments, setMechanicComments] = useState<string>("");
    const [statusOptions, setStatusOptions] = useState<any[]>([]);
    const [selectedStatus, setSelectedStatus] = useState<number>(0);
    const [mechanicOption, setMechanicOption] = useState([]);
    const [pleaseWait, setPleaseWait] = useState<boolean>(false);
    const [editorState, setEditorState] = useState(() =>
        EditorState.createEmpty()
    );

    useEffect(() => {
        fetch(`${baseURL}maintenanceStatus`, {
            headers: {
                'X-Tenant-ID': tenantId,
            }
        })
            .then((res) => res.json())
            .then((data) => {
                setStatusOptions(
                    data.map((item: any) => {
                        return { value: item.id, label: item.name };
                    })
                );
                handleTenantError(null);
            }).catch((error) => {
                setStatusOptions([]);
                handleTenantError(error);
            })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        axios
           .get(`${baseURL}users`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                }
            })
            .then((response) => {
                setMechanicOption(
                    response?.data?.map((item: any) => {
                        return {
                            value: item.id,
                            label: item.firstName + " " + item.lastName,
                        };
                    })
                );
                handleTenantError(null);
            })
            .catch((error) => {
                setMechanicOption([]);
                handleTenantError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (repairOrderId > 0) {
            setPleaseWait(true);
            axios
                .get(`${baseURL}vehicleRepairOrder/${repairOrderId}`, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                    }
                })
                .then((response) => {
                    setMaintenanceType(response.data.maintenanceType);
                    setTotalInParts(response.data.totalInParts);
                    setTotalInLabour(response.data.totalInLabour);
                    setTotal(response.data.total);
                    setOdometerIn(response.data.odoMeterIn);
                    setOdometerOut(response.data.odoMeterOut);
                    setSelectedStatus(Number(response.data.status));
                    setNotes(response.data.notes);
                    setDateOut(response.data.dateOut.split("T")[0]);
                    setTimeOut(response.data.dateOut.split("T")[1]);
                    setDateDue(response.data.dateDue.split("T")[0]);
                    setTimeDue(response.data.dateDue.split("T")[1]);
                    setMechanic(response.data.mechanic);
                    setMechanicComments(response.data.comments);
                    setEditorState(
                        EditorState.createWithContent(
                            ContentState.createFromBlockArray(
                                convertFromHTML(response.data.notes).contentBlocks,
                                convertFromHTML(response.data.notes).entityMap
                            )
                        )
                    );
                    setPleaseWait(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setPleaseWait(false);
                    handleTenantError(error);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [repairOrderId]);

    useEffect(() => {
        axios
            .get(`${baseURL}fileUploadData/GetFileUploadDatasByAttribute?attributeName=vehicleRepairOrder&attributeId=${repairOrderId}`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                }
            })
            .then((response) => {
                setFilePath(() =>
                    response?.data?.map((item: any) => {
                        return {
                            id: item.id,
                            fileName: item.fileName.startsWith("data:image/png;base64,")
                                ? item.fileName
                                : `${baseURL}repairOrderFile/Get?name=` +
                                item.fileName,
                        };
                    })
                );
                handleTenantError(null);
            })
            .catch((error) => {
                handleTenantError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        axios
            .get(`${baseURL}maintenanceType/GetMaintenanceTypesWithActiveStatus/true`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                }
            })
            .then((response) => {
                setMaintenanceTypeOptions(() =>
                    response?.data?.map((item: any) => {
                        return { value: item.id, label: item.maintenanceName };
                    })
                );
                handleTenantError(null);
            })
            .catch((error) => {
                setMaintenanceTypeOptions([]);
                handleTenantError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const dateTimeOut = new Date(`${dateOut}T${timeOut}`)?.toISOString();
        const dateTimeDue = new Date(`${dateDue}T${timeDue}`)?.toISOString();

        if (dateTimeDue <= dateTimeOut) {
            setConfirmData({
                title: 'Warning',
                summary: "Estimated date and time cannot be earlier than or the same as date out.",
                confirmBtn: 'Ok',
                isConfirm: async (callback: any) => {
                    callback();
                }
            });
            setConfirmPopup(true);

            return;
        }

        setPleaseWait(true);

        if (newFilePath?.length !== 0) {
            newFilePath?.forEach((item: string, index: number) => {
                axios
                    .post(
                        `${baseURL}fileUploadData?userId=${auth?.id}`,
                        JSON.stringify({
                            attributeName: "VehicleRepairOrder",
                            attributeId: repairOrderId,
                            fileName: item?.replace(
                                `${baseURL}repairOrderFile/Get?name=`,
                                ""
                            ),
                            tabName: "VehicleRepairOrder",
                            userId: auth?.id ?? 0,
                            createdDate: new Date(),
                        }),
                        {
                            headers: {
                                'X-Tenant-ID': tenantId,
                                "Content-Type": "application/json"
                            },
                            withCredentials: true,
                        }
                    )
                    .then(() => {
                        if (newFilePath?.length - 1 === index) {
                            updateTheRepairOrder();
                        }
                        handleTenantError(null);
                    })
                    .catch((error) => {
                        setPleaseWait(false);
                        handleTenantError(error);
                    });
            });
        } else {
            updateTheRepairOrder();
        }
    };

    const updateTheRepairOrder = () => {
        axios
            .put(
                `${baseURL}vehicleRepairOrder?userId=${auth?.id}`,
                JSON.stringify({
                    id: repairOrderId,
                    vehicleId: idNumber?.state,
                    maintenanceType,
                    totalInParts,
                    totalInLabour,
                    total,
                    odoMeterIn: odometerIn,
                    odoMeterOut: odometerOut,
                    status: selectedStatus.toString(),
                    notes,
                    dateOut: timeOut === "T00:00:00" ? dateOut + timeOut : dateOut + ("T" + timeOut),
                    dateDue: timeDue === "T00:00:00" ? dateDue + timeDue : dateDue + ("T" + timeDue),
                    mechanic,
                    comments: mechanicComments,
                }),
                {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "application/json"
                    },
                    withCredentials: true,
                }
            )
            .then(() => {
                setPleaseWait(false);
                setOpenEditRepairOrder(false);
                setRefreshRepairOrderList(true);
                handleTenantError(null);
            })
            .catch((error) => {
                setPleaseWait(false);
                handleTenantError(error);
            });
    }


    const webRef = useRef(null);
    const inputFileRef = useRef<HTMLInputElement>(null);
    const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPleaseWait(true);
        const selectedFiles = e.target.files as FileList;

        if (selectedFiles.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);

            axios
                .post(`${baseURL}repairOrderFile/upload`, formData, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    const newFilePath: any = {
                        id: 0,
                        fileName:
                            `${baseURL}repairOrderFile/Get?name=` +
                            response.data,
                    };

                    setNewFilePath((prevPath: string[]) => [
                        ...prevPath,
                        newFilePath.fileName,
                    ]);
                    setFilePath((prevPath: any[]) => [...prevPath, newFilePath]);
                    setPleaseWait(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    handleTenantError(error);
                });
        } else {
            setPleaseWait(false);
        }
    };



    const updateFile = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {

        setPleaseWait(true);
        const selectedFiles = e.target.files as FileList;
        if (selectedFiles.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);
            axios
                .post(`${baseURL}repairOrderFile/upload`, formData, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: true,
                })
                .then((response) => {

                    put_fileUpload({
                        id,
                        attributeName: "VehicleRepairOrder",
                        attributeId: repairOrderId,
                        fileName: response.data,
                        tabName: "VehicleRepairOrder",
                        userId: auth?.id ?? 0,
                        createdDate: new Date()
                    }, auth?.id, tenantId)
                        .then(() => {
                            setFilePath((prevPath: any[]) =>
                                prevPath.map(file =>
                                    file.id === id ? {
                                        ...file, fileName: `${baseURL}repairOrderFile/Get?name=` +
                                            response.data,
                                    } : file
                                )
                            );
                            setPleaseWait(false);
                            handleTenantError(null);
                        })
                        .catch((error) => {
                            const errorMessage = error?.response?.data?.message || error?.message || "File upload failed.";
                            setConfirmData({
                                title: 'Warning',
                                summary: errorMessage,
                                confirmBtn: 'Ok',
                                isConfirm: (callback: any) => {
                                    callback();
                                }
                            });
                            setConfirmPopup(true);
                            setPleaseWait(false);
                            handleTenantError(error);
                        })
                        handleTenantError(null);
                })
                .catch((error) => {
                    setPleaseWait(false);
                    handleTenantError(error);
                });
        } else {
            setPleaseWait(false);
        }


    }

    useEffect(() => {
        setNotes(draftToHtml(convertToRaw(editorState.getCurrentContent())));
    }, [editorState]);

    const deleteRepairOrder = () => {
        setDeleteData({
            id: idNumber,
            tilte: `Delete`,
            summary: `Are you sure you want to delete this Repair Order?`,
            isDelete: (callback: any) => {
                callback();

                setPleaseWait(true);

                fetch(`${baseURL}vehicleRepairOrder?id=${repairOrderId}&userId=${auth?.id}`, {
                    method: 'DELETE',
                    headers: {
                        'X-Tenant-ID': tenantId,
                    }
                })
                    .then(() => {
                        setPleaseWait(false);
                        setOpenEditRepairOrder(false);
                        setRefreshRepairOrderList(true);
                        handleTenantError(null);
                    })
                    .catch((error) => {
                        setPleaseWait(false);
                        handleTenantError(error);
                    });

                callback();
            }
        });
        setDeletePopup(true);
    };

    return (
        <>
            <Dialog
                open={openEditRepairOrder}
                maxWidth="md"
                fullScreen={false}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '550px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[10px] py-[5px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>

                                    <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Edit Repair Order</h2>

                                    <span className={`material-symbols-outlined text-[25px] font-light cursor-pointer ${themeStyles.main.textHeadingColor}`} onClick={() => setOpenEditRepairOrder(false)}>close</span>

                                </div>
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <div className="w-full px-2">
                                        <span className={`text-[14px] font-semibold inline-block my-2 ${themeStyles.main.textHeadingColor}`}>
                                            General Information
                                        </span>

                                        <Divider className={`w-full ${themeStyles.divider.bg}`} />

                                        <div className="w-full mt-4">
                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Maintenance Type</label>
                                                <select
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={maintenanceType}
                                                    onChange={(e) => setMaintenanceType(e.target.value)}
                                                >
                                                    {maintenanceTypeOptions.map((item: any, index: number) => {
                                                        return (
                                                            <option
                                                                key={index}
                                                                className={`${themeStyles.main.tailwindSectionBg}`}
                                                                value={item.value}
                                                            >
                                                                {item.label}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-2 gap-6 mt-4">
                                            <div className="space-y-4">
                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Total In Parts</label>
                                                    <input
                                                        type="number"
                                                        min={0}
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={totalInParts}
                                                        onChange={(e) =>
                                                            setTotalInParts(validateMin(e.target.value, 0))
                                                        }
                                                        required
                                                    />

                                                </div>

                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Total</label>
                                                    <input
                                                        type="number"
                                                        step={0.01}
                                                        min={0}
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={total}
                                                        onChange={(e) => setTotal(validateMin(e.target.value, 0).toString())}
                                                        required
                                                    />

                                                </div>
                                            </div>

                                            <div className="space-y-4">
                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Total In Labor</label>
                                                    <input
                                                        type="number"
                                                        min={0}
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={totalInLabour}
                                                        onChange={(e) =>
                                                            setTotalInLabour(validateMin(e.target.value, 0))
                                                        }
                                                        required
                                                    />

                                                </div>

                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Status</label>
                                                    <select
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={selectedStatus}
                                                        onChange={(e) => setSelectedStatus(Number(e.target.value))}
                                                    >
                                                        <option className={`${themeStyles.main.tailwindSectionBg}`} value={0}>None</option>
                                                        {
                                                            statusOptions.map((item: any, index: number) => {
                                                                return <option key={index} className={`${themeStyles.main.tailwindSectionBg}`} value={item.value}>{item.label}</option>
                                                            })
                                                        }

                                                    </select>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-4 w-full">
                                            <div className="w-full flex flex-row items-center gap-[5px] flex-wrap">
                                                {
                                                    filePath?.map((item: any, outerIndex: number) => (
                                                        <React.Fragment key={outerIndex}>
                                                            <img
                                                                src={item.fileName}
                                                                width={40}
                                                                height={40}
                                                                alt="repairOrder"
                                                                onClick={() => {
                                                                    setFileIndex(outerIndex);
                                                                    setImagePopup(true);
                                                                }}
                                                            />
                                                            <RemoveCircleIcon
                                                                className={`text-[14px] ${themeStyles.main.textSubHeadingColor} font-bold  hover:text-red-500 cursor-pointer`}
                                                                onClick={() => {

                                                                    setConfirmData({
                                                                        title: 'Delete image',
                                                                        summary: 'Are you sure you want to delete this image?',
                                                                        confirmBtn: 'Yes',
                                                                        isConfirm: (callback: any) => {
                                                                            let newFileSet: string[] = filePath.filter(
                                                                                (_, index: number) => index !== outerIndex
                                                                            );
                                                                            if (filePath[outerIndex].id === 0) {
                                                                                setFilePath(() => newFileSet);
                                                                            }
                                                                            else {
                                                                                delete_fileUpload(filePath[outerIndex]?.id, auth?.id, tenantId)
                                                                                    .then(() => {
                                                                                        setFilePath(() => newFileSet);
                                                                                        handleTenantError(null);
                                                                                    })
                                                                                    .catch((error) => {
                                                                                        handleTenantError(error);
                                                                                    });
                                                                            }
                                                                            callback();
                                                                        }
                                                                    });

                                                                    setConfirmPopup(true);
                                                                }}
                                                            />
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </div>

                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Images</label>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    ref={inputFileRef}
                                                    onChangeCapture={onFileChangeCapture}
                                                    style={{ display: "none" }}
                                                />
                                                <div className="flex flex-row gap-2 mt-2">
                                                    <p
                                                        className="border border-dashed border-black rounded px-2 py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                                                        onClick={() => {

                                                            if (inputFileRef.current !== null) {
                                                                inputFileRef.current.value = "";

                                                            }
                                                            inputFileRef.current?.click();
                                                        }}
                                                    >
                                                        <AddIcon className="text-[#167AC3] text-[14px] font-bold" />
                                                        Add Image
                                                    </p>

                                                    <p
                                                        className="border border-dashed border-black rounded px-2 py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                                                        onClick={() => setShowWebcam(true)}
                                                    >
                                                        <LocalSeeIcon className="text-[#167AC3] text-[14px] font-bold" />
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-4 w-full">
                                            <span className={`text-[14px] font-semibold inline-block my-2 ${themeStyles.main.textHeadingColor}`}>
                                                Notes
                                            </span>

                                            <Divider className={`w-full ${themeStyles.divider.bg}`} />

                                            <div className="w-full mt-2">
                                                <Editor
                                                    editorStyle={{
                                                        border: `1px solid #D0D0D0`,
                                                        backgroundColor: "white"
                                                    }}
                                                    editorState={editorState}
                                                    wrapperClassName="wrapper-class"
                                                    editorClassName="editor-class"
                                                    toolbarClassName="toolbar-class"
                                                    onEditorStateChange={setEditorState}
                                                    toolbar={{
                                                        inline: { inDropdown: true },
                                                        list: { inDropdown: true },
                                                        textAlign: { inDropdown: true },
                                                        link: { inDropdown: true },
                                                        history: { inDropdown: true },
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="mt-4 w-full">
                                            <span className={`text-[14px] font-semibold inline-block my-2 ${themeStyles.main.textHeadingColor}`}>
                                                Vehicle Out Information
                                            </span>

                                            <Divider className={`w-full ${themeStyles.divider.bg}`} />

                                            <div className="grid grid-cols-2 gap-6 mt-4">

                                                <div className="space-y-4">
                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Date Out</label>
                                                        <CustomFormatDatePicker
                                                            value={dateOut}
                                                            onChange={setDateOut}
                                                            dateFormat={dateFormat}
                                                            required={true}
                                                        />

                                                    </div>
                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Estimated Date In</label>
                                                        <CustomFormatDatePicker
                                                            value={dateDue}
                                                            onChange={setDateDue}
                                                            dateFormat={dateFormat}
                                                            minDate={dateOut}
                                                            required={true}
                                                        />

                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Odometer Out</label>
                                                        <input
                                                            type="number"
                                                            min={0}
                                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                            value={odometerOut}
                                                            onChange={(e) => setOdometerOut(validateMin(e.target.value, 0).toString())}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="space-y-4">
                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Time Out</label>
                                                        <input
                                                            type="time"
                                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                            value={timeOut}
                                                            onChange={(e) => setTimeOut(e.target.value)}
                                                            required
                                                        />

                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Estimated Time In</label>
                                                        <input
                                                            type="time"
                                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                            value={timeDue}
                                                            onChange={(e) => setTimeDue(e.target.value)}
                                                            required
                                                        />
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Odometer In</label>
                                                        <input
                                                            type="number"
                                                            min={0}
                                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                            value={odometerIn}
                                                            onChange={(e) => setOdometerIn(validateMin(e.target.value, 0).toString())}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div className="mt-4 w-full">
                                            <span className={`text-[14px] font-semibold inline-block my-2 ${themeStyles.main.textHeadingColor}`}>
                                                Internal Management
                                            </span>

                                            <Divider className={`w-full ${themeStyles.divider.bg}`} />
                                            <div className="w-full mt-4">
                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Mechanic</label>
                                                    <Select
                                                        styles={{
                                                            control: (base, state) => ({
                                                                ...base,
                                                                backgroundColor: "transparent",
                                                                color: themeStyles.form.inputTextColor,
                                                                borderRadius: '6px',
                                                                padding: '1px',
                                                                borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                                                minHeight: "40px",
                                                            }),
                                                            menu: (base) => ({
                                                                ...base,
                                                                fontSize: "14px",
                                                                backgroundColor: themeStyles.main.mainBg,
                                                                color: themeStyles.form.inputTextColor,
                                                                marginBottom: "14px",
                                                            }),
                                                            menuList: (base) => ({
                                                                ...base,
                                                                paddingTop: 0,
                                                                paddingBottom: 0,
                                                                maxHeight: "170px",
                                                            }),
                                                            option: (base, state) => ({
                                                                ...base,
                                                                paddingTop: "6px",
                                                                paddingBottom: "6px",
                                                                backgroundColor: state.isSelected
                                                                    ? "#167AC3"
                                                                    : state.isFocused
                                                                        ? themeStyles.topBar.menuItemsHoverColor
                                                                        : "transparent",
                                                                color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                                                fontWeight: 600,
                                                            }),
                                                            input: (base) => ({
                                                                ...base,
                                                                color: themeStyles.form.inputTextColor,
                                                            }),
                                                            singleValue: (base) => ({
                                                                ...base,
                                                                color: themeStyles.form.inputTextColor,
                                                            }),
                                                        }}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        isLoading={false}
                                                        isClearable={false}
                                                        isRtl={false}
                                                        isSearchable={false}
                                                        name="mechanic"
                                                        value={mechanicOption.find(
                                                            (item: any) => item.value === Number(mechanic)
                                                        )}
                                                        onChange={(mechanic: any) =>
                                                            setMechanic(mechanic ? mechanic.value : "")
                                                        }
                                                        options={mechanicOption}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mt-4 w-full">
                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Comments</label>
                                                <textarea
                                                    className={`w-full px-[8px] py-[8px]  border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    rows={6}
                                                    value={mechanicComments}
                                                    onChange={(e) => setMechanicComments(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="flex mt-4 gap-4">
                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.main.bg
                                                }}
                                                type="submit">
                                                Save
                                            </Button>

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color
                                                }}
                                                onClick={() => setOpenEditRepairOrder(false)}>
                                                Cancel
                                            </Button>

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.delete.bg,
                                                }}
                                                onClick={deleteRepairOrder}>
                                                Delete
                                            </Button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog
                open={showWebcam}
                maxWidth="md"
                fullScreen={false}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '500px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[10px] py-[5px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>WebCam</h2>
                                    </div>
                                </div>

                                <div className="mt-2 p-2">
                                    <div className="w-full">
                                        <Webcam
                                            width={500}
                                            height={320}
                                            ref={webRef}
                                            screenshotFormat="image/png"
                                            audio={false}
                                        />

                                        <div className="flex gap-4 mt-6">
                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color
                                                }}
                                                onClick={() => {
                                                    setShowWebcam(false)
                                                }}>
                                                Cancel
                                            </Button>

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.main.bg
                                                }}
                                                onClick={() => {
                                                    if (webRef.current !== null) {
                                                        //@ts-ignore
                                                        const imageSrc = webRef.current.getScreenshot();

                                                        handleCapture(imageSrc, `${baseURL}repairOrderFile/upload`, tenantId, (imageFilePath: string) => {
                                                            if (imageFilePath) {
                                                                setFilePath((prevFileString: string[]) => [
                                                                    ...prevFileString,
                                                                    `${baseURL}repairOrderFile/Get?name=${imageFilePath}`,
                                                                ]);
                                                            }
                                                        })

                                                        setShowWebcam(false);
                                                    }
                                                }}
                                            >
                                                Capture an Image
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <CustomImagePopup
                showPopup={imagePopup}
                handlePopup={() => setImagePopup(false)}
                filePath={filePath}
                fileIndex={fileIndex}
                setFileIndex={setFileIndex}
                imageBaseUrlPath="repairOrderFile"
                updateFile={updateFile}
            />

            <PleaseWaitPopup pleaseWaitPopup={pleaseWait} />
        </>
    )
}